import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'propagationElement',
    'mealInput',
    'gedMealInput',
    'daysListCheck',
    'daysList',
    'noChangeRadio',
    'mealChoice',
    'dayListWrapper',
  ];

  connect() {
    this.setupMealInputListeners();

    // daysListCheckTarget is by default false so init the initial state to false
    this.dayListCheckInitialState = false;
  }

  setupMealInputListeners() {
    if (this.hasMealInputTarget) {
      this.addMealChoiceListeners(this.mealChoiceTarget.querySelectorAll('.radio_button > label'), 'click');
    }
  }

  showDayList() {
    this.dayListCheckInitialState = this.daysListCheckTarget.checked;
    this.toggleElement(this.daysListTarget, !this.daysListCheckTarget.checked);
  }

  togglePropagationDisplay() {
    // When user wants to change hour range, store state and reset meal propagation
    this.toggleMealPropagationDisplay();
    this.preventMealPropagation();
  }

  addMealChoiceListeners(elements, eventName) {
    elements.forEach((element) => {
      element.addEventListener(eventName, () => {
        // wait for the change event to finish before toggling the propagation display
        setTimeout(() => {
          this.toggleMealPropagationDisplay();
        }, 10);
      });
    });
  }

  toggleMealPropagationDisplay() {
    // si a des horaires conforme et qu'il y a une différence de repas, on affiche la propagation
    const condition = !this.noChangeRadioTarget.checked || !this.hasMealDiff();
    this.toggleElement(this.propagationElementTarget, condition);
    if (!condition) { this.revertDayListCheckState(); }
  }

  revertDayListCheckState() {
    // reset le style du toggle (uncheck quand les horaires ne sont pas conformes)
    this.dayListWrapperTarget.querySelector('.toggle-wrapper').classList.toggle('checked', this.dayListCheckInitialState);
    this.daysListCheckTarget.checked = this.dayListCheckInitialState;
  }

  hasMealDiff() {
    return this.inputsToCheck().some((input) => this.hasValueChanged(input));
  }

  hasValueChanged(input) {
    const defaultValue = input.dataset.defaultValue;

    if (this.hasMealInputTarget) {
      return defaultValue !== input.value;
    } else if (this.hasGedMealInputTarget) {
      const isChecked = input.parentElement.classList.contains('checked');
      return defaultValue !== isChecked.toString();
    }
  }

  inputsToCheck() {
    if (this.hasMealInputTarget) {
      return this.mealInputTargets.filter((input) =>
        input.closest('.radio_button.checked')
      );
    } else if (this.hasGedMealInputTarget) {
      return this.gedMealInputTargets;
    }
  }

  preventMealPropagation() {
    // si n'a pas d'horaire conforme et que la propagation est activée, on la désactive
    if (!this.noChangeRadioTarget.checked && this.daysListCheckTarget.checked) {
      this.daysListCheckTarget
        .closest('.toggle-wrapper')
        .classList.remove('checked');
      this.daysListCheckTarget.checked = false;
    }
  }

  toggleElement(element, condition) {
    element.classList.toggle('d-none', condition);
  }
}
